import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { CommunityService } from '../communities.service';

@Component({
    selector: 'community-conn-banner',
    templateUrl: './community-connection.component.html',
    styleUrls: ['./community-connection.component.scss'],
    standalone: true,
    imports: [TranslocoPipe],
})
export class BannerCommunityConn implements OnInit, OnDestroy {
    expanded = false;
    communityStatus: 'online' | 'offline' | null = null;
    private sub?: Subscription;

    /**
     * Constructor
     */
    constructor(private _communityService: CommunityService) {}

    ngOnInit() {
        this.communityStatus = 'online';
        this._communityService.getInternetMonitoringEnabled().subscribe({
            next: (result) => {
                if (result?.enabled) {
                    this.sub = this._communityService.getConnectionStatus().subscribe((status: 'online' | 'offline') => {
                        this.communityStatus = status;
                    });
                }
            },
            error: () => {
                // fail-safe: no banner if we can't determine monitoring status
            },
        });
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }

    toggleBanner() {
        this.expanded = !this.expanded;
    }
}
